<div
  class="flex items-center w-max relative"
  bdNoScroll
  [bdClippyPeek]="showClippy"
  [clippyWiggleEyebrows]="moveClippyEyebrows"
>
  @let avatars = avatars$ | async;
  @let showMinimal = showMinimal$ | async;
  @let toolbarSecondaryButton = toolbarSecondaryButton$ | async;
  @let toolbarPrimaryButton = toolbarPrimaryButton$ | async;
  @let canManageTrialInvites =
    ('trialInvite' | actionState: 'manage' | async) === 'accessible';
  @if (
    accountToolbarSettings.showTrialWidget &&
    featureFlags.trialExperienceEnabled()
  ) {
    <bd-trial-widget
      class="pr-2 pl-2"
      data-id="account-toolbar-trial-widget"
      [showInviteButton]="
        accountToolbarSettings.showTrialInviteButton && canManageTrialInvites
      "
      (inviteClicked)="inviteDialogVisible.set(true)"
    />
    @if (inviteDialogVisible() && canManageTrialInvites) {
      <bd-trial-invite-dialog-container
        [visible]="true"
        (visibleChange)="inviteDialogVisible.set($event)"
      />
    }
  }
  @if (!showMinimal) {
    @if (accountToolbarSettings.showAvatarGroups) {
      @if (avatars) {
        <bd-avatar-group-menu
          [avatars]="avatars"
          [areCursorsVisible]="
            (accountToolbarService.showCollabCursors$ | async)!
          "
          (toggleCursorsVisibility)="
            accountToolbarService.showCollabCursors$.next($event)
          "
        ></bd-avatar-group-menu>
      }
    }
    @if (
      accountToolbarSettings.showTrialStatusButton &&
      featureFlags.trialExperienceEnabled()
    ) {
      <bd-trial-status-button
        class="pr-2 pl-2"
        data-id="account-toolbar-trial-status-button"
      />
    }
    @if (accountToolbarSettings.showToolbarSecondaryButton) {
      @if (
        toolbarSecondaryButton ?? undefined | translateActionButton | async;
        as button
      ) {
        <p-button
          class="pr-2 pl-2"
          data-id="account-toolbar-button-secondary"
          [bdActionButton]="button"
          (onClick)="button.onClick($event)"
          [pTooltip]="button.tooltip ?? ''"
          tooltipPosition="bottom"
          [showDelay]="500"
        ></p-button>
      }
    }
    @if (accountToolbarSettings.showToolbarPrimaryButton) {
      @if (
        toolbarPrimaryButton ?? undefined | translateActionButton | async;
        as button
      ) {
        <p-button
          class="pr-2 pl-2"
          data-id="account-toolbar-button-primary"
          [bdActionButton]="button"
          (onClick)="button.onClick($event)"
          [pTooltip]="button.disabled ? button.tooltip : ''"
          tooltipStyleClass="bd-tooltip-free-width"
          tooltipPosition="left"
          [showDelay]="500"
        ></p-button>
      }
    }
  }
  @if (accountToolbarSettings.showAccountNotifications) {
    <bd-account-notifications
      [accountNotificationsItems]="accountNotificationsItems"
      [isFirstToolbarItem]="
        (!accountToolbarSettings.showAvatarGroups &&
          !accountToolbarSettings.showToolbarSecondaryButton &&
          !accountToolbarSettings.showToolbarPrimaryButton) ||
        !avatars?.length
      "
    />
  }
  @if (accountToolbarSettings.showAccountMenu) {
    <bd-account-menu
      [userAvatar]="userAvatar"
      [accountMenuItems]="accountMenuItems"
      [appendTo]="'body'"
      [isFirstToolbarItem]="
        (showMinimal ||
          (!(accountToolbarSettings.showAvatarGroups && avatars?.length) &&
            !(
              accountToolbarSettings.showToolbarSecondaryButton &&
              toolbarSecondaryButton
            ) &&
            !(
              accountToolbarSettings.showToolbarPrimaryButton &&
              toolbarPrimaryButton
            ))) &&
        !accountToolbarSettings.showAccountNotifications
      "
    />
  }
</div>
